var UserProfile = /** @class */ (function () {
    function UserProfile(userName, userPicture) {
        this.userName = userName;
        this.userPicture = userPicture;
    }
    return UserProfile;
}());
export { UserProfile };
